export default __webpack_public_path__ + "static/media/neo-moto.1adbccec.png";